import changeLoggedIn from '../slices/auth/authActions/changeLoggedIn';
import { selectedChannelIdChanged } from '../slices/channels/channelsSlice';
import scrollToMessageId from '../slices/chat/chatThunks/scrollToMessageId';
import { updateAgentAvailabilityStatus, updateAvailabilityDate } from '../slices/currentAgent/currentAgentThunks';
import { changeFileListTab } from '../slices/fileList/fileListSlice';
import { trackGAEvent } from '../slices/googleAnalytics/googleAnalyticsThunks';
import { deleteMessageOffline } from '../slices/messageInput/messageInputActions/deleteMessageOffline';
import { sendMessagesOffline } from '../slices/messageInput/messageInputActions/sendMessagesOffline';
import {
  channelInputForwardMessagesStaged,
  channelInputProcessStaged,
  channelInputProductStaged,
  channelInputReplyMessageStaged,
} from '../slices/messageInput/messageInputSlice';
import { processSelected, productSelected, suggestionSelected } from '../slices/processes/processesSlice';
import { taskReminderHidden } from '../slices/tasks/tasksSlice';
import { setLeftBarTab, setToolbarTab } from '../slices/uiState/uiStateSlice';

export const getRegisteredGoogleAnalyticsEvents = (dispatch) => {
  const track = (category, action) => dispatch(trackGAEvent(category, action));

  return [
    {
      reduxActionType: channelInputReplyMessageStaged.type,
      event: () => track('MESSAGE_ACTION', 'QUICK_REPLY'),
    },
    {
      reduxActionType: changeLoggedIn.type,
      event: ({ payload: { loggedIn } }) => {
        if (loggedIn) {
          track('LOGIN', 'END_LOGIN');
        }
      },
    },
    {
      reduxActionType: selectedChannelIdChanged.type,
      event: () => track('CHANNEL', 'SWITCHED'),
    },
    {
      reduxActionType: suggestionSelected.type,
      event: () => track('MAGIC_CUBE', 'SELECT_SUGGESTION'),
    },
    {
      reduxActionType: channelInputForwardMessagesStaged.type,
      event: () => track('FORWARD_MESSAGE', 'OPENED'),
    },
    {
      reduxActionType: scrollToMessageId.fulfilled.type,
      event: () => track('MESSAGE', 'SCROLL_TO_MESSAGE'),
    },
    {
      reduxActionType: deleteMessageOffline.type,
      event: () => track('MESSAGE', 'MESSAGE_DELETED'),
    },
    {
      reduxActionType: sendMessagesOffline.type,
      event: ({ meta: { messages } }) => {
        for (const message of messages) {
          const { messageType, isForwarded } = message;
          if (isForwarded) {
            track('MESSAGE', 'FORWARD_MESSAGE_SENT');
          } else if (messageType) {
            track('MESSAGE', `${messageType}_MESSAGE_SENT`);
          } else {
            track('MESSAGE', 'MESSAGE_SENT');
          }
        }
      },
    },
    {
      reduxActionType: changeFileListTab.type,
      event: ({ payload: { fileListTab } }) => track('SAVED_FILES', `CHANGED_TO_${fileListTab}`),
    },
    {
      reduxActionType: setToolbarTab.type,
      event: ({ payload: { tab } }) => track('TODO', `OPEN_${tab}_MENU`),
    },
    {
      reduxActionType: updateAvailabilityDate.fulfilled.type,
      event: ({
        meta: {
          arg: { type },
        },
      }) => track('ABSENCE_MANAGER', `CHANGE_DATE_TYPE:${type}`),
    },
    {
      reduxActionType: updateAgentAvailabilityStatus.fulfilled.type,
      event: ({
        meta: {
          arg: { statusType },
        },
      }) => track('ABSENCE_MANAGER', `ADD_NOTICE:${statusType}`),
    },
    {
      reduxActionType: setLeftBarTab.type,
      event: ({ payload: { leftBarTab } }) => track(leftBarTab, 'OPENED'),
    },
    {
      reduxActionType: taskReminderHidden.type,
      event: () => track('TODO', 'HIDE_REMINDER'),
    },
    {
      reduxActionType: channelInputProductStaged.type,
      event: () => track('MAGIC_CUBE', 'PRODUCT_INSERTED_TO_CHAT'),
    },
    {
      reduxActionType: channelInputProcessStaged.type,
      event: () => track('MAGIC_CUBE', 'PROCESS_INSERTED_TO_CHAT'),
    },
    {
      reduxActionType: productSelected.type,
      event: () => track('MAGIC_CUBE', 'PRODUCT_SELECTED'),
    },
    {
      reduxActionType: processSelected.type,
      event: () => track('MAGIC_CUBE', 'PROCESS_SELECTED'),
    },
  ];
};
